import React from 'react'

const DownArrowIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="7.227" height="6" viewBox="0 0 7.227 6"><path d="M33.293 20.168a.465.465 0 0 0-.411-.27h-6.287a.465.465 0 0 0-.411.27.842.842 0 0 0 0 .621l3.144 4.839a.447.447 0 0 0 .821 0l3.144-4.839a.842.842 0 0 0 0-.621zm-3.554 4.127l-2.322-3.236h4.628z" transform="translate(-26.125 -19.898)" fill={props.fill} /></svg>
)

export default DownArrowIcon